import React from "react";
import { Box, Stack, Typography } from "@mui/material";

export const HomePageBanner = ({ title, subTitle = '', hasBorderRadius = false, bannerImage, withGradient = true, ...others }) => {

  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'center'}
      alignItems={'center'}
    >
      <Box
        {...others}
        sx={{
          color: '#FFF',
          backgroundImage: withGradient ? `linear-gradient(to left, rgba(0, 0, 0, 0) 0%, rgba(15, 74, 105, 0.85) 85%), url(${bannerImage})` : `url(${bannerImage})`,
          backgroundSize: 'cover',
          backgroundPosition: { xs: 'center', mds: 'top' },
          height: { xs: '150px', md: '200px' },
          padding: '0px 24px',
          alignItems: 'center',
          display: 'flex',
          borderRadius: hasBorderRadius ? '16px' : '0px',
          width: { xs: '100%', xsm: '100%', mds: '1044px', sm: '1043px', lg: '1308px', xl: '1570px', xxl: '1835px' }
        }}
      >
        <Stack gap={1}>
          <Typography variant="h1" fontSize={{ xs: '18px', md: '32px' }} fontWeight={700} lineHeight={{ xs: '21.78px', md: '38.73px' }}>
            {title}
          </Typography>
          <Typography variant="body1" fontSize={{ xs: '14px', md: '16px' }} fontWeight={700} lineHeight={{ xs: '20px', md: '27px' }}>
            {subTitle}
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};